import numericToWord from 'utils/numericToWord'
import { generateMonthName, formatDay } from 'utils/formatDate'
import { MINUTE, HOUR, ONE_DAY } from 'constants/timeslot'

const minuteVariants = ['минуту', 'минуты', 'минут']
const hourvariants = ['час', 'часа', 'часов']

const formatPublicationDate = (date: string | Date | undefined) => {
  if (!date) return
  const now = new Date().getTime()
  const delta = now - Number(date)
  if (delta < MINUTE) return 'только что'
  if (delta < HOUR) {
    const mins = Math.floor(delta / MINUTE)
    return `${mins} ${numericToWord(Number(mins), minuteVariants)} назад`
  }
  if (delta >= HOUR && delta < ONE_DAY) {
    const hours = Math.floor(delta / HOUR)
    return `${hours} ${numericToWord(Number(hours), hourvariants)} назад`
  }
  if (delta >= ONE_DAY && delta < 2 * ONE_DAY) {
    return 'Вчера'
  }
  const formatedDate = Number(date) ? new Date(Number(date)) : new Date(date)
  const monthName = generateMonthName(formatedDate)
  const year = formatedDate.getFullYear()
  const day = formatDay(formatedDate)
  return `${day} ${monthName} ${year}`
}

export { formatPublicationDate }
